import axiosBaseApi from '../common/lib/axiosBaseApi';

export const postNote = (targetUserId: string, content: string) => {
  return axiosBaseApi.post(`/v1/user/${targetUserId}/profile/notes`, {
    content,
  });
};

export const deleteNote = (noteId: string) => {
  return axiosBaseApi.delete(`/v1/user/profile/notes/${noteId}`);
};

export const patchNoteColor = (targetUserId: string, color: string | null) => {
  return axiosBaseApi.patch(`/v1/user/${targetUserId}/profile`, {
    notesColor: color,
  });
};
